import api from "./api";
import { Bairro, Option, PaginatedList } from "../types/localidade";
import { PaginatedBairroResponse } from "../types/bairro";

interface BairroListParams {
  municipio?: string | number;
  search?: string;
  limit?: number;
  offset?: number;
}

export const bairroService = {
  async listar(params: BairroListParams): Promise<PaginatedBairroResponse> {
    const response = await api.get<PaginatedBairroResponse>(
      "/api/bairros-base/",
      { params }
    );
    return response.data;
  },

  // Alterado para aceitar ID do município e retornar Option[]
  listarPorMunicipio: async (municipioId: number): Promise<Option[]> => {
    const url = "/api/bairros-base/";
    const params = { municipio: municipioId, limit: 5000 }; // Adicionado limit para buscar todos
    console.log(
      "[DEBUG] Chamando bairroService.listarPorMunicipio. URL:",
      url,
      "Params:",
      params
    );
    // A API retorna um objeto paginado, então esperamos PaginatedList<Bairro>
    const response = await api.get<PaginatedList<Bairro>>(url, { params });

    // Mapeia os resultados para o formato Option
    return response.data.results.map((b) => ({
      value: b.nome,
      label: b.nome_original,
    }));
  },
};
